import { Main } from './main';
import cls from 'classnames';

import styles from './index.module.less';

interface IProps {
  helpCenterUrl: string;
}

export const Banner = ({ helpCenterUrl }: IProps) => {
  return (
    <div
      className={cls(
        'break-word w100 flex-col-center flex-items-center',
        styles.banner
      )}
    >
      <Main helpCenterUrl={helpCenterUrl} />
    </div>
  );
};
